(function () {
    'use strict';

    angular
        .module('salesflare.components.largerprospectfollowup.onboardingQuestions', [])
        .component('sfOnboardingQuestions', {
            templateUrl: 'app-ajs/components/largerprospectfollowup/onboardingQuestions/onboardingQuestions.html',
            controller,
            controllerAs: 'vm',
            bindings: {
                answers: '<',
                onSave: '&'
            }
        });

    function controller($mdDialog, $mdMedia, $translate) {

        const vm = this;

        vm.$mdMedia = $mdMedia;

        vm.goalOptions = [
            { value: 'Follow up leads better', label: $translate.instant('Follow up leads better') },
            { value: 'Collaborate better as a team', label: $translate.instant('Collaborate better as a team') },
            { value: 'Send personal emails at scale', label: $translate.instant('Send personal emails at scale') },
            { value: 'Track our performance', label: $translate.instant('Track our performance') },
            { value: 'Find new leads', label: $translate.instant('Find new leads') }
        ];
        vm.previousCRMOptions = [
            { value: 'Nothing', label: $translate.instant('Nothing') },
            { value: 'Spreadsheet', label: $translate.instant('Spreadsheet') },
            { value: 'Salesforce', label: $translate.instant('Salesforce') },
            { value: 'HubSpot', label: $translate.instant('HubSpot') },
            { value: 'Pipedrive', label: $translate.instant('Pipedrive') },
            { value: 'Other', label: $translate.instant('Other') }
        ];
        vm.potentialUsersOptions = ['1-2', '3-5', '6-10', '11-25', '25+'];

        vm.$onInit = () => {

            vm.answers = vm.answers || {};
        };

        vm.next = () => {

            if (vm.questionsForm.$valid && vm.onSave) {
                return vm.onSave({
                    $event: {
                        answers: vm.answers
                    }
                });
            }
        };
    }
})();
